<template>    
    <div class='item'>
    {{text}}
    </div>
</template>

<script>
export default {
    props: ['text']
}
</script>

<style scoped>
.item{
    display:inline-block;
    padding: 0px 30px 0px 30px;        
    margin: 0 60px 0 60px;
    font-size: 30px;
    background: none;
    cursor: pointer;
}
</style>